import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getDeliveryTime = deliveryZoneId =>
  axios({
    method: 'post',
    url: `${publicAPI}/order/getdeliverytime/${deliveryZoneId}`,
  });
